import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewEncapsulation
} from '@angular/core';
import { ActivatedRoute, ActivationEnd, NavigationEnd, Params, Router } from '@angular/router';
import {IonContent, ModalController, Platform, PopoverController} from '@ionic/angular';
// stores
import {RestaurantStore} from '../../../core/stores/restaurant.store';
import {CartStore} from 'src/app/core/stores/cart.store';
// models
import {Group, Merchant, Restaurant, RestaurantAddress, RestaurantAvailableStatus} from '../../../core/models/restaurant.model';
import {QueueInfo} from '../../../core/models/order.model';
// rxjs
import { Subject, Subscription } from 'rxjs';
import {filter, takeUntil} from 'rxjs/operators';
// constants
// services
import {RouteService} from '../../../core/services/route.service';
// components
import {CartComponent} from '../cart/cart.component';
import {OrdersStatusComponent} from '../orders-status/orders-status.component';
import {MerchantStore} from '../../../core/stores/merchant.store';
import {Title} from '@angular/platform-browser';
import {parsePhoneNumberFromString} from 'libphonenumber-js';
import {HeaderTextPopoverComponent} from '../header-text-popover/header-text-popover.component';
import {ItemValidateService} from '../../../core/services/item-validate.service';
import {PaymentStore} from '../../../core/stores/payment.store';
import {TabOrdersStatusComponent} from '../tab-orders-status/tab-orders-status.component';
import {Autolinker} from 'autolinker';
import {StatusBar} from '@ionic-native/status-bar/ngx';
import {SecurityContext} from '@angular/core';
import {NgDompurifySanitizer} from '@tinkoff/ng-dompurify';
import {LocationListComponent} from '../location-list/location-list.component';
import { BASE_URL_PATH, STONE_CREEK_MERCHANT_ID } from 'src/app/core/constants';
import { OrderApiService } from 'src/app/core/services/order.api.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { UtilService } from 'src/app/core/services/util.service';
import { Platforms } from 'src/app/core/enums/util.enum';
import {SharedOrderService} from '../../../core/services/shared-order.service';
import { OrderWithFlavorStore } from 'src/app/core/stores/orderwithflavor.store';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HeaderComponent implements OnInit, OnChanges, OnDestroy {
  private destroyed$ = new Subject();
  private readonly pathRestaurantIndex: number = 1;
  private readonly pathRestaurantIdIndex: number = 2;
  private readonly HEADER_TEXT_CUTOFF_LENGTH: number = 150;
  private readonly defaultBanner = './assets/images/back.jpg';

  public isCartOpen: boolean;
  public hideETA: boolean;
  public chosenRestaurant: Restaurant;
  public numPersonsAhead: number;
  public queueInfo: QueueInfo;
  public currentRestaurantId: string;
  public restaurants: Restaurant[] = [];
  public restaurantName: string;
  public headerTextIsCollapsed = true;
  public isHeaderTextPopoverOpen = false;
  public restaurantsInGroup: Restaurant[];
  public params: Params;
  public locationIndex:number = 0;
  public merchant: Merchant;
  private routeSubscription: Subscription = new Subscription();

  @Input() isHome: boolean;
  @Input() pageName: ('merchant' | 'location');
  @Input() logo;
  @Input() sourceBanner: string;
  @Input() fromPayment: boolean;
  @Input() short: boolean;
  @Input() locationId: string;
  @Input() isCollapse = false;
  @Input() isGroup = false;
  @Input() ordersIsEmpty: boolean;
  @Input() hideOrdersAhead: boolean;
  @Input() merchantName: string;
  @Input() merchantHeaderTitle: string;
  @Input() merchantHeaderText: string;
  @Input() group: Group;
  @Input() hidePhoneIcon = false;
  @Input() showLocationModal = false;
  @Input() showMerchantLogo = false;
  @Input() isCreek: boolean = false;

  @Output() selectRestaurant = new EventEmitter<number>();
  @Output() clearData =  new EventEmitter();

  @ViewChild(IonContent, {static: true}) content: IonContent;
  @ViewChild('chartButton', {static: false, read: ElementRef}) chartButton: ElementRef;
  @ViewChild('ordersButton', {static: false, read: ElementRef}) ordersButton: ElementRef;
  @ViewChild('tabsButton', {static: false, read: ElementRef}) tabsButton: ElementRef;
  @ViewChild('headerTextButton', {static: false, read: ElementRef}) headerTextButton: ElementRef;
  @ViewChild('locationsTabContainer', {static: false, read: ElementRef}) locationsTabContainer: ElementRef;
  @ViewChild('locationsWrapper', {static: false, read: ElementRef}) locationsWrapper: ElementRef;
  @ViewChildren('locationsTab', {read: ElementRef}) locationsTab: QueryList<ElementRef>;

  public static getQueueInfo(restaurantAvailableStatus: RestaurantAvailableStatus): QueueInfo {
    return {
      placeInLine: restaurantAvailableStatus.placeInLine,
      estimatedTimeToBeginPreparation: restaurantAvailableStatus.estimatedTimeToBeginPreparation,
      numPersonsAhead: restaurantAvailableStatus.numPersonsAhead,
      maxOrdersInQueue: restaurantAvailableStatus.maxOrdersInQueue
    };
  }

  public get isStoneCreek(): boolean {
    return this.utilService.isStoneCreek();
  }

  public get banner() {
    return `url(${this.sourceBanner ? this.sourceBanner : ''})`;
  }

  public get isMobile(): boolean {
    return this.platform.is('mobile') || this.platform.width() < 600;
  }

  public get isTab(): boolean {
    return !!this.cartStore.tab || !!this.cartStore.groupTab;
  }

  public get isMoreThanOneRestaurant(): boolean {
    return this.restaurants.length > 1;
  }

  public get showBackToLocationsButton(): boolean {
    return this.allowAllLocationButton
      && !this.isMobile
      && !this.sharedOrderService.sharedOwnerId$
      && !this.sharedOrderService.sharedOrderId$;
  }

  public get showAllLocationsButton(): boolean {
    return this.allowAllLocationButton
      && this.isMobile
      && !this.sharedOrderService.sharedOwnerId$
      && !this.sharedOrderService.sharedOrderId$;
  }

  public get allowAllLocationButton(): boolean {
    return this.isLocationPage && this.isMoreThanOneRestaurant && !this.isGroup && this.chosenRestaurant?.showAllLocationsButton;
  }

  public get isMerchantPage(): boolean {
    return this.pageName === 'merchant';
  }

  public get isLocationPage(): boolean {
    return this.pageName === 'location';
  }

  public get showRightButtons(): boolean {
    return !this.isMobile && this.isLocationPage;
  }

  public get ShowOrdersAheadButton(): boolean {
    return this.isHome && !!this.queueInfo && !this.hideOrdersAhead && !this.isTab;
  }

  public get backgroundImage(): string {
    if (this.isMobile && this.isGroup && this.isCollapse) {
      const locationBanner = this.restaurantsInGroup[this.restaurantStore.activeLocationIndex].locationBanner;
      return this.formatToStyleImageUrl(locationBanner ? locationBanner : this.defaultBanner);
    }
    return this.banner;
  }

  public get name(): string {
    if (this.isGroup) {
      return this.group ? this.group.displayName : '';
    }
    const name = this.isMerchantPage ? this.merchantName : this.chosenRestaurantName;
    return name || '';
  }

  public get locationsTabListLeft() {
    return this.locationsTab.map((category) => category.nativeElement.offsetLeft);
  }

  public get locationsTabArray() {
    return this.locationsTab.toArray();
  }

  public get address(): string {
    let address = '';
    if (this.isLocationPage) {
      if ((!this.isGroup && this.chosenRestaurant != null && this.chosenRestaurant.address != null) || (this.isGroup && this.group != null && this.group.address != null)) {
        const addressObject: RestaurantAddress =  this.isGroup ? this.group.address : this.chosenRestaurant.address;
        const addressFields: string[] = ['addressLine', 'locality', 'state', 'postalCode'];
        for (const field of addressFields) {
          if (addressObject[field] != null) {
            address += field !== 'state' ? this.titleCase(addressObject[field]) : addressObject[field];
            address += addressObject[field].length > 0 && field !== 'state' && field !== 'postalCode' ? ',' : '';
            address += addressObject[field].length > 0 && field !== 'postalCode' ? ' ' : '';
          }
        }
        address = address.trim().endsWith(',') ? address.trim().slice(0, -1) : address.trim();
      }
    }
    return address;
  }

  public get isRestaurantHeaderText(): boolean {
    return this.chosenRestaurant != null && !!this.chosenRestaurant.locationHeaderText;
  }

  public get showSeeMoreText(): boolean {
    const currentHeaderText = this.merchantHeaderText ? this.merchantHeaderText : this.chosenRestaurantHeaderText;
    return currentHeaderText != null && currentHeaderText.length > this.HEADER_TEXT_CUTOFF_LENGTH && this.headerTextIsCollapsed;
  }

  public get headerModalTitle(): string {
    return this.headerTitle != null && this.headerTitle.length > 0 && this.headerTitle.substr(0, 25) !== this.headerText.substring(0, 25) ? this.headerTitle : '';
  }

  public get headerModalText(): string {
    return this.headerText;
  }

  public get activeLocationIndex(): number {
    return this.restaurantStore.activeLocationIndex;
  }

  public get chosenRestaurantHeaderTitle(): string {
    if (this.isGroup) {
      return this.group && this.group.groupHeaderTitle ? this.group.groupHeaderTitle : '';
    }
    return this.chosenRestaurant != null && this.chosenRestaurant.locationHeaderTitle ? this.chosenRestaurant.locationHeaderTitle : '';
  }

  public get chosenRestaurantHeaderText(): string {
    if (this.isGroup) {
      return this.group && this.group.groupHeaderText ? this.group.groupHeaderText : '';
    }
    return this.chosenRestaurant != null && this.chosenRestaurant.locationHeaderText ? this.chosenRestaurant.locationHeaderText : '';
  }

  public get chosenRestaurantName(): string {
    return this.chosenRestaurant != null && this.chosenRestaurant.name ? this.chosenRestaurant.name : '';
  }

  public get headerTitle(): string {
    const currentHeaderTitle = this.isMerchantPage ? this.merchantHeaderTitle : this.chosenRestaurantHeaderTitle;
    const currentHeaderText = this.isMerchantPage ? this.merchantHeaderText : this.chosenRestaurantHeaderText;
    if (this.isMobile && currentHeaderText && (currentHeaderTitle == null || currentHeaderTitle.length === 0)) {
      return `${currentHeaderText.substring(0, 25)}...`;
    }
    return currentHeaderText && currentHeaderTitle.length > 0 && !this.isMobile ? currentHeaderTitle + ':' : currentHeaderTitle;
  }

  public get headerText(): string {
    const currentHeaderText = this.isMerchantPage ? this.merchantHeaderText : this.chosenRestaurantHeaderText;
    const formattedHeaderText = Autolinker.link(this.purify(this.getFormattedHeaderText(currentHeaderText)), {
      newWindow: true,
      urls: true,
      email: false,
      phone: false,
      mention: false,
      hashtag: false,
      sanitizeHtml: false,
      className: 'header__store-header-text'
    });
    return formattedHeaderText;
  }

  public get showLocationsListLeftArrow(): boolean {
    return this.locationsWrapper && this.locationsWrapper.nativeElement && this.locationsWrapper.nativeElement.scrollLeft > 10;
  }

  public get showLocationsListRightArrow(): boolean {
    return this.locationsWrapper && this.locationsWrapper.nativeElement &&
      this.locationsWrapper.nativeElement.scrollWidth - 10 > this.locationsWrapper.nativeElement.clientWidth + this.locationsWrapper.nativeElement.scrollLeft;
  }

  public get activeLocationBanner(): string {
    return this.restaurantsInGroup && this.restaurantsInGroup[this.restaurantStore.activeLocationIndex].locationBanner ? this.restaurantsInGroup[this.restaurantStore.activeLocationIndex].locationBanner : './assets/images/back.jpg';
  }

  public get activeLocationName(): string {
    return this.restaurantsInGroup && this.restaurantsInGroup[this.restaurantStore.activeLocationIndex].name ? this.restaurantsInGroup[this.restaurantStore.activeLocationIndex].name : '';
  }

  public get currentRestaurant(): Restaurant {
    if (this.isGroup) {
      return this.restaurantsInGroup[0];
    }
    return this.restaurants.find((location) => location.locationId === this.locationId);
  }

  public getFormattedHeaderText(currentHeaderText: string): string {
    let formattedHeaderText = '';
    if (currentHeaderText != null && currentHeaderText.length > this.HEADER_TEXT_CUTOFF_LENGTH && this.headerTextIsCollapsed) {
      formattedHeaderText = `${currentHeaderText.substr(0, this.HEADER_TEXT_CUTOFF_LENGTH)}...`;
    } else {
      formattedHeaderText = currentHeaderText;
    }

    // TODO: Turn PizzaHacker hack into dynamic eta/prep time
    if ((this.router.url.includes('MLYBKPZ0VW6DW') || this.router.url.includes('CWCFNGXXQCJKS')) && this.chosenRestaurant != null && this.chosenRestaurant.availableStatus != null) {
      formattedHeaderText += ` ETA: ~${this.leadTimeService.convertLeadTimeToMinutes(this.chosenRestaurant.availableStatus.estimatedTimeToBeginPreparation)} min wait `;
    }
    return formattedHeaderText;
  }

  public showFullHeaderText() {
    this.headerTextIsCollapsed = false;
  }

  public titleCase(str: string) {
    return str.toLowerCase().split(' ').map(function(word) {
      return (word.charAt(0).toUpperCase() + word.slice(1));
    }).join(' ');
  }

  constructor(
    public cartStore: CartStore,
    public paymentStore: PaymentStore,
    public popoverController: PopoverController,
    public leadTimeService: ItemValidateService,
    public restaurantStore: RestaurantStore,
    private merchantStore: MerchantStore,
    private router: Router,
    private route: ActivatedRoute,
    private routeService: RouteService,
    private titleService: Title,
    public platform: Platform,
    private statusBar: StatusBar,
    private modalController: ModalController,
    private orderApiService: OrderApiService,
    private storageService: StorageService,
    private utilService: UtilService,
    private readonly dompurifySanitizer: NgDompurifySanitizer,
    public sharedOrderService: SharedOrderService,
    private orderWithFlavorStore: OrderWithFlavorStore
  ) {
  }

  ngOnInit() {
    if (this.fromPayment) {
      this.cartStore.items.length = 0;
    }

    this.routeSubscription.add(this.router.events.pipe(filter(event => event instanceof ActivationEnd ))
      .subscribe( (event: ActivationEnd) => this.params = event.snapshot.params));
    this.routeSubscription.add( this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (event.url.includes(`locations/groups`)) {
          this.restaurantStore.getGroupById(this.params.groupId).subscribe((data: Group) => {
            this.setBackground(data.bannerImageUrl);
          });
        }
        if (this.isGroup) {
          if (event.urlAfterRedirects.includes('groups') && !event.urlAfterRedirects.includes('locations')) {
            this.restaurantStore.getRestaurants()
              .pipe(takeUntil(this.destroyed$), filter(Boolean))
              .subscribe((restaurants: Restaurant[]) => {
                if (restaurants.length !== 0) {
                  this.restaurantsInGroup = JSON.parse(JSON.stringify(restaurants));
                  if (this.restaurantStore.selectedLocationInGroup) {
                    this.sortBySelectedLocationInGroup();
                  }
                  this.chosenRestaurant = this.restaurantsInGroup[0];
                  this.currentRestaurantId = this.chosenRestaurant.locationId;
                }
              });
          }
        }
      }
    }));

    if (!this.isGroup) {
      this.route.params.subscribe(params => {
        if (this.isLocationPage) {
          this.getRestaurantAvailableStatus();
        }
        this.restaurantStore
        .getRestaurantById(params.locationId)
        .pipe(takeUntil(this.destroyed$))
        .subscribe(restaurant => {
          if (restaurant) {
            this.chosenRestaurant = restaurant;
            this.setBackground(restaurant.locationBanner);
            this.logo = restaurant.logoUrl;
            this.setFavicon();
            this.restaurantName = restaurant.name;
          }
        });
      });
      
      this.getMerhcant();
      this.restaurantStore.restaurants$
        .pipe(takeUntil(this.destroyed$))
        .subscribe(restaurants => {
          this.restaurants = restaurants;
          if (restaurants.length > 0) {
            this.numPersonsAhead = restaurants[0].numPersonsAhead;
          }
        });
      this.listenRestaurantAvailableStatus();
    } else {
      this.listenRestaurantsAvailableStatus();
      this.restaurantStore.activeLocationIndex$.pipe(takeUntil(this.destroyed$))
        .subscribe((activeLocationIndex)=>{
          if(activeLocationIndex != this.locationIndex){
            this.locationIndex = activeLocationIndex;
            this.locationsTabArray[this.locationIndex].nativeElement.scrollIntoView({inline: 'center'});
          }
        })
    }

  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.routeSubscription.unsubscribe();
  }

  public setFavicon() {
    const link: HTMLBaseElement = document.querySelector(`link[rel~='icon']`);
    if (link && this.logo) {
      link.href = this.logo;
    }
  }

  public formatToStyleImageUrl(image: string): string {
    return `linear-gradient( rgba(0,0,0,.6), rgba(0,0,0,.6) ), url(${image})`;
  }

  public async chooseLocation(index: number) {
    if (!this.locationsTabArray[index] || this.restaurantStore.activeLocationIndex === index) {
      return;
    }
    this.restaurantStore.activeLocationIndex = index;
    this.locationsTabArray[index].nativeElement.scrollIntoView({inline: 'center'});
    this.selectRestaurant.emit(index);
  }

  public async chooseLocationMobile() {
    if (!this.restaurantsInGroup) {
      return;
    }
    const modal = await this.modalController.create({
      component: LocationListComponent,
      componentProps: {
        locationList: this.restaurantsInGroup,
        chosenLocationIndex: this.restaurantStore.activeLocationIndex
      }
    });

    modal.onDidDismiss().then((data) => {
      const result = data['data'] ? data['data'].locationIndex : null;
      if (result != null) {
        this.restaurantStore.activeLocationIndex = data['data'].locationIndex;
        this.selectRestaurant.emit(this.restaurantStore.activeLocationIndex);
      }
    });
    await modal.present();
  }

  public scrollToPreviousCategoryTabs() {
    const nextScrollPosition = this.locationsWrapper.nativeElement.scrollLeft;
    const scrollToIndex = this.locationsTabListLeft.findIndex((categoryTabLeft, index) => {
      if (index !== 0) {
        const previousCategoryTabLeft = this.locationsTabListLeft[index - 1];
        return previousCategoryTabLeft <= nextScrollPosition && nextScrollPosition <= categoryTabLeft;
      }
    });
    this.locationsTabArray[scrollToIndex].nativeElement.scrollIntoView({inline: 'end', behavior: 'smooth'});
  }

  ngOnChanges(changes) {
    if (this.platform.is(Platforms.IOS)) {
      this.isCollapse ? this.statusBar.styleDefault() : this.statusBar.styleLightContent();
    }
  }

  public scrollToNextCategoryTabs() {
    const nextScrollPosition = this.locationsWrapper.nativeElement.clientWidth + this.locationsWrapper.nativeElement.scrollLeft;
    const scrollToIndex = this.locationsTabListLeft.findIndex((categoryTabLeft, index) => {
      if (index !== this.locationsTabListLeft.length - 1) {
        const nextCategoryTabLeft = this.locationsTabListLeft[index + 1];
        return categoryTabLeft <= nextScrollPosition && nextScrollPosition <= nextCategoryTabLeft;
      } else {
        return true;
      }
    });
    this.locationsTabArray[scrollToIndex].nativeElement.scrollIntoView({inline: 'start', behavior: 'smooth'});
  }

  public formatPhoneNumber(phone: string, formatType: string, country: any = 'US'): string {
    if (phone) {
      const phoneNumber = parsePhoneNumberFromString(phone.toString(), country);
      if (formatType === 'national') {
        return phoneNumber.formatNational();
      } else if (formatType === 'international') {
        return phoneNumber.formatInternational();
      }
    }
    return '';
  }

  public goToHomePage(): void {
    const baseUrl = this.routeService.getBaseUrl();
    this.restaurantStore.clearRestaurantData();
    this.merchantStore.merchantData$
      .pipe(filter(Boolean))
      .subscribe( (merchant: Merchant) => {
        if (merchant.merchantName) {
          this.titleService.setTitle( merchant.merchantName );
        }
      });
    this.router.navigate([baseUrl])
      .catch(error => console.log(error));
  }

  public async showOrdersAhead(ev) {
    const marginBottom = 10;
    const modalTop = this.ordersButton.nativeElement.getBoundingClientRect().bottom + marginBottom;
    const modalRight = window.innerWidth - this.ordersButton.nativeElement.getBoundingClientRect().right;

    document.documentElement.style.setProperty('--orders-popover-desktop-top', `${modalTop}px`);
    document.documentElement.style.setProperty('--orders-popover-desktop-right', `${modalRight}px`);

    const popover = await this.popoverController.create({
      component: OrdersStatusComponent,
      componentProps: {
        locationId: this.locationId,
        isGroup: this.isGroup,
        queueInfo: this.queueInfo
      },
      cssClass: ['orders-popover'],
      event: ev,
      translucent: true
    });
    return await popover.present();
  }

  public async showHeaderText(ev) {
    const marginBottom = 10;
    const modalTop = this.headerTextButton.nativeElement.getBoundingClientRect().bottom + marginBottom;

    document.documentElement.style.setProperty('--orders-popover-desktop-top', `${modalTop}px`);

    const popover = await this.popoverController.create({
      component: HeaderTextPopoverComponent,
      componentProps: {
        title: this.headerModalTitle,
        text: this.headerModalText
      },
      cssClass: ['header-text-popover'],
      event: ev,
      translucent: true
    });
    this.isHeaderTextPopoverOpen = true;
    popover.onDidDismiss().then(() => {
      this.isHeaderTextPopoverOpen = false;
    });
    return await popover.present();
  }

  public async showOrdersInTab(ev) {
    const marginBottom = 10;
    const modalTop = this.tabsButton.nativeElement.getBoundingClientRect().bottom + marginBottom;
    const modalRight = window.innerWidth - this.tabsButton.nativeElement.getBoundingClientRect().right;

    document.documentElement.style.setProperty('--orders-popover-desktop-top', `${modalTop}px`);
    document.documentElement.style.setProperty('--orders-popover-desktop-right', `${modalRight}px`);

    const popover = await this.popoverController.create({
      component: TabOrdersStatusComponent,
      componentProps: {},
      cssClass: ['orders-popover'],
      event: ev,
      translucent: true
    });
    return await popover.present();
  }

  public async showCart(ev) {
    this.restaurantStore.isGoToCheckout = true;
    if (!this.cartStore.items.length) {
      return;
    }

    const marginBottom = 10;
    const modalTop = this.chartButton.nativeElement.getBoundingClientRect().bottom + marginBottom;
    const modalRight = window.innerWidth - this.chartButton.nativeElement.getBoundingClientRect().right;

    document.documentElement.style.setProperty('--cart-popover-desktop-top', `${modalTop}px`);
    document.documentElement.style.setProperty('--cart-popover-desktop-right', `${modalRight}px`);

    const popover = await this.popoverController.create({
      component: CartComponent,
      componentProps: {
        isGroup: this.isGroup,
        restaurant: this.chosenRestaurant,
        restaurantsInGroup: this.restaurantsInGroup
      },
      event: ev,
      cssClass: ['cart-popover', 'cart-popover--desktop'],
      translucent: true
    });
    this.isCartOpen = true;
    popover.onDidDismiss().then(() => {
      this.isCartOpen = false;
    });
    return await popover.present();
  }

  public getLocationBanner(location: Restaurant) {
    return location.locationBanner ? location.locationBanner : this.defaultBanner;
  }

  public openLocationInMaps(restaurantAddress: RestaurantAddress) : void {
    this.utilService.openLocationInMaps(restaurantAddress);
  }

  public openSubscriptionsPage() {
    this.router.navigate([this.routeService.getLocationUrl(), 'my-subscriptions'])
      .catch(error => console.error(error));
  }

  public backToShop(): void {
    this.router.navigate([BASE_URL_PATH, STONE_CREEK_MERCHANT_ID]);
  }

  private getRestaurantAvailableStatus(): void {
    this.restaurantStore.restaurantIsAvailable$.subscribe( result => {
      if (result) {
        this.restaurantStore.restaurantAvailableStatus$
          .pipe(filter(Boolean), takeUntil(this.destroyed$))
          .subscribe((restaurantAvailableStatus: RestaurantAvailableStatus) => {
            if (restaurantAvailableStatus.isHidden) {
              this.goToHomePage();
            }
          });
      } else {
        this.restaurantStore.setRestaurantIsAvailable(true);
        this.goToHomePage();
      }
    });
  }

  private listenRestaurantAvailableStatus(): void {
    this.restaurantStore.restaurantAvailableStatus$
      .pipe(filter(Boolean))
      .subscribe((restaurantAvailableStatus: RestaurantAvailableStatus) => {
        this.hideETA = restaurantAvailableStatus.hideETA;
        this.queueInfo = HeaderComponent.getQueueInfo(restaurantAvailableStatus);
      });

  }

  private listenRestaurantsAvailableStatus(): void {
    this.restaurantStore.restaurants$
      .pipe(filter(Boolean))
      .subscribe((restaurants: Restaurant[]) => {
        this.hideETA = !restaurants.find((restaurant) => restaurant.hideETA === false);
        const restaurantsQueueInfo = restaurants.map((restaurant) => HeaderComponent.getQueueInfo(restaurant.availableStatus));
        let groupQueueInfo: QueueInfo;
        for (const queueInfo of restaurantsQueueInfo) {
          if (!groupQueueInfo) {
            groupQueueInfo = queueInfo;
          } else {
            groupQueueInfo.numPersonsAhead += queueInfo.numPersonsAhead;
            groupQueueInfo.placeInLine += queueInfo.placeInLine;
            groupQueueInfo.maxOrdersInQueue += queueInfo.maxOrdersInQueue;
            if (this.leadTimeService.convertLeadTimeToMinutes(queueInfo.estimatedTimeToBeginPreparation) > this.leadTimeService.convertLeadTimeToMinutes(groupQueueInfo.estimatedTimeToBeginPreparation)) {
              groupQueueInfo.estimatedTimeToBeginPreparation = queueInfo.estimatedTimeToBeginPreparation;
            }
          }
        }
        this.queueInfo = groupQueueInfo;
      });

  }

  private getCurrentRestaurant(): string {
    const paths = this.router.url.split('/');
    return paths[this.pathRestaurantIndex] === 'locations'
      ? paths[this.pathRestaurantIdIndex]
      : 'switch';
  }

  public openCloseTabPage() {
    const url = this.isGroup ? this.routeService.getGroupUrl() : this.routeService.getLocationUrl();
    this.router.navigate([url, 'close-tab'])
      .catch(error => console.error(error));
  }

public async openLocationModal() {
    const modal = await this.modalController.create({
      component: LocationListComponent,
      componentProps: {
        locationList: this.restaurants,
        chosenLocationIndex: this.restaurantStore.activeLocationIndex,
      }
    });

    modal.onDidDismiss().then(async (data) => {
      const result = data['data'] ? data['data'].locationIndex : null;
      if (result != null) {
        this.restaurantStore.activeLocationIndex = data['data'].locationIndex;
        this.chosenRestaurant = this.restaurants[this.restaurantStore.activeLocationIndex];
        const currentRestaurantId = this.chosenRestaurant.locationId;
        if (this.locationId !== currentRestaurantId) {
          this.restaurantStore.clearCurCategoriesAndCurProducts();
          this.utilService.isLoaderActive = false;
          this.cartStore.deleteItemsFromCartByLocationId(this.locationId);
          this.orderApiService.removeLocationFromOrderMap(this.locationId);
          this.storageService.set('currentRestaurantId', currentRestaurantId);
          this.clearData.emit(currentRestaurantId);
        }
    }
    });
    await modal.present();
  }

  public navigateToHome(): void {
    this.utilService.navigateToHome();
  }

  public getMerhcant(): void {
    this.merchantStore.merchantData$.pipe(takeUntil(this.destroyed$)).subscribe(merchant => {
      this.merchant = merchant;
      if(merchant && merchant.useFlavorShiftsTime){
        this.restaurantStore.getRestaurants().subscribe(restaurants =>{
          if(restaurants.length) {
            this.orderWithFlavorStore.loadShifts(merchant.vanityLink, restaurants);
            this.orderWithFlavorStore.restaurants$.pipe(takeUntil(this.destroyed$)).subscribe((r)=>{
              if(r.length){
                this.getFlavorRestaurant()
              }
            })
          }
        })
      }
    })
  }
  public async getFlavorRestaurant(): Promise<void> {
    let address = await this.storageService.get("address")
    this.orderWithFlavorStore.getRestaurantById(this.locationId, address)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(restaurant =>{
        if(restaurant){
          this.chosenRestaurant = restaurant
          this.restaurantName = restaurant.name
        }
      });
  }

  private sortBySelectedLocationInGroup() {
    const index = this.restaurantsInGroup.findIndex(el => el.locationId === this.restaurantStore.selectedLocationInGroup);
    if (index && index !== -1) {
      this.restaurantsInGroup.unshift(...this.restaurantsInGroup.splice(index, 1));
    }
  }

  private setBackground(urlPath: string): void {
    if (urlPath) {
      this.sourceBanner = urlPath;
      return;
    }
    this.sourceBanner = this.defaultBanner;
  }

  private purify(value: string): string {
    return this.dompurifySanitizer.sanitize(SecurityContext.HTML, value);
  }
}
